import { PhaseTag } from '@concord/ui';
import { useState } from 'react';
import { Link } from 'react-router';
import s from './auth.module.css';

/**
 * Under the sign-in card: the other ways in. Patients and care navigators have their own
 * sign-in pages; physicians have no account in Phase 1 and answer from the secure link in
 * their invitation email (accounts arrive in Phase 3).
 */
export function WhoSwitch({ current }: { current: 'patient' | 'staff' }) {
  const [physician, setPhysician] = useState(false);
  return (
    <div className={s.who}>
      <nav aria-label="Sign in as" className={s.whoRow}>
        <span className={s.whoLabel}>Sign in as</span>
        <Link to="/sign-in" aria-current={current === 'patient' && !physician ? 'page' : undefined}>
          Patient
        </Link>
        <Link to="/console/sign-in" aria-current={current === 'staff' && !physician ? 'page' : undefined}>
          Care navigator
        </Link>
        <button type="button" aria-expanded={physician} onClick={() => setPhysician((v) => !v)}>
          Physician
        </button>
      </nav>
      {physician && (
        <p className={s.whoNote} role="note">
          Physicians do not need an account yet. Open the secure link in your invitation email to read the
          case and answer. Lost the email? Contact the care navigator who invited you.{' '}
          <span className={s.whoPhase}>
            Physician accounts <PhaseTag phase="P3" />
          </span>
        </p>
      )}
    </div>
  );
}
